import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { InjectionToken } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

// Import Moment.js locales for DatePicker internationalization
// Note: English is the default locale in Moment.js, no import needed
import 'moment/locale/fr';

import { globalConfig } from './global.config';
import { MpsAppComponent } from './mps/components/mps-app/mps-app.component';

registerLocaleData(localeFr); // MPS TODO: Adapt to your locale

export const OAUTH2_PROVIDERS_URL = new InjectionToken<string>('OAUTH2_PROVIDERS_URL');
export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');
export const LOADER_ON_HTTP = new InjectionToken<string>('LOADER_ON_HTTP');

bootstrapApplication(MpsAppComponent, globalConfig).catch((err) => console.error(err));
